<div class="container-table">

  <div class="app-title">Employee-Task App </div>
  <p class="app-description">This App allows you to manage your employees and their tasks.
    You can perform all CRUD (Create, Read, Update, Delete) operations, allowing management of employee data and task assignments.</p>

    <button mat-raised-button color="primary" (click)="createEmployeeDialog()">
      Create Employee
    </button>

  <div style="margin-top: 10px;">

    <mat-form-field>
      <mat-label>Find a employee</mat-label>
      <input matInput (keyup)="applyFilter($event)" placeholder="Ex. Mia" #input>
    </mat-form-field>

    <div class="mat-elevation-z8">
      <table mat-table [dataSource]="dataSource" matSort>

        <!-- First Name Column -->
        <ng-container matColumnDef="firstName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> First Name </th>
          <td mat-cell *matCellDef="let row"> {{row.firstName}} </td>
        </ng-container>

        <!-- Last Name Column -->
        <ng-container matColumnDef="lastName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Last Name </th>
          <td mat-cell *matCellDef="let row"> {{row.lastName}} </td>
        </ng-container>

        <!-- Email Column -->
        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Email </th>
          <td mat-cell *matCellDef="let row"> {{row.email}} </td>
        </ng-container>

        <!-- Gender Column -->
        <ng-container matColumnDef="gender">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Gender </th>
          <td mat-cell *matCellDef="let row"> {{row.gender}} </td>
        </ng-container>

        <!-- Action Column -->
        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Actions </th>
          <td mat-cell *matCellDef="let row">
            <button mat-icon-button style="color: green" (click)="updateEmployeeDialog(row)">
              <mat-icon>edit</mat-icon>
            </button>
            <button mat-icon-button color="warn" (click)="deleteEmployee(row.id)">
              <mat-icon>delete</mat-icon>
            </button>
            <button mat-icon-button style="color: blue" (click)="addTaskToEmployee(row)">
              <mat-icon>note_add</mat-icon>
            </button>
            <button mat-icon-button style="color: gray" (click)="showTasksFromEmployee(row)">
              <mat-icon>notes</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

        <!-- Row shown when there is no matching data. -->
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" colspan="4">No employees found {{input.value}}</td>
        </tr>
      </table>

      <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]" aria-label="Select page of users"></mat-paginator>
    </div>


  </div>

</div>
